import React from 'react';
export function SalesFooter() {
  return <footer className="bg-[#0a1420] py-8 px-4 border-t border-[#1a2e4a]" data-id="element-125">
      <div className="max-w-3xl mx-auto text-center" data-id="element-126">
        <p className="text-gray-500 text-xs md:text-sm leading-relaxed" data-id="element-127">
          <strong data-id="element-128">Aviso Legal:</strong> Este producto es una guía educativa de
          bienestar y no sustituye el consejo médico profesional, diagnóstico o
          tratamiento. Si experimentas síntomas severos de ansiedad o depresión,
          consulta a un profesional de salud mental. Los resultados pueden
          variar según cada persona.
        </p>
        <p className="text-gray-600 text-xs mt-4" data-id="element-129">
          © {new Date().getFullYear()} Calma en el Turno. Todos los derechos
          reservados.
        </p>
      </div>
    </footer>;
}